import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_PROJECT_ID: createActionType(FULL_NAMESPACE, "SET_PROJECT_ID"),
    SET_NEW_PROJECT: createActionType(FULL_NAMESPACE, "SET_NEW_PROJECT"),
    SET_DRAFT: createActionType(FULL_NAMESPACE, "SET_DRAFT"),
    GET_PROJECT: createActionType(FULL_NAMESPACE, "GET_PROJECT"),
    GET_PROJECT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_PROJECT_COMPLETED"),
    SAVE_PROJECT: createActionType(FULL_NAMESPACE, "SAVE_PROJECT"),
    SAVE_PROJECT_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_PROJECT_COMPLETED")
};
